import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { ro } from "date-fns/locale/ro";
import "react-datepicker/dist/react-datepicker.css";

registerLocale("ro", ro);

function pad(n) {
  return String(n).padStart(2, "0");
}

function EditEvent({ event, onSuccess }) {
  const [isOpen, setIsOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [name, setName] = useState("");
  const [dateTime, setDateTime] = useState(null);
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (event && isOpen) {
      setName(event.title || "");
      setDateTime(event.date ? new Date(`${event.date}T${event.time || "00:00"}`) : null);
      setDescription(event.description || "");
      setPreviewUrl(`https://awaretherapycenter.ro/${event.image}`);
      setSuccess("");
      setError("");
    }
  }, [event, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", name);
    formData.append(
      "date",
      dateTime ? `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1)}-${pad(dateTime.getDate())}` : ""
    );
    formData.append(
      "time",
      dateTime ? `${pad(dateTime.getHours())}:${pad(dateTime.getMinutes())}` : ""
    );
    formData.append("description", description);
    if (image) {
      formData.append("image", image);
    }

    try {
      const token = localStorage.getItem("access_token");

      const response = await fetch(
        `https://awaretherapycenter.ro/events-back/${event.id}/update/`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      let data = null;
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      }

      if (response.ok) {
        setSuccess("Eveniment actualizat cu succes!");
        onSuccess?.();

        setTimeout(() => {
          setIsOpen(false);
        }, 2000);
      } else {
        setError(data?.error || "Eroare la actualizare.");
      }
    } catch (err) {
      console.error("Eroare rețea:", err);
      setError("Eroare de rețea.");
    }
  };

  return (
    <div>
      <button
        className="evp-icon-btn"
        onClick={() => {
          setIsOpen(true);
          setSuccess("");
          setError("");
        }}
        aria-label="Editează evenimentul"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>
      </button>

      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="evp-overlay">
        <div className="evp-overlay-bg" aria-hidden="true" />
        <div className="evp-dialog-scroll">
          <Description className="sr-only" />
          <form onSubmit={handleSubmit}>
            <DialogPanel className="evp-dialog-box">
              <button type="button" className="evp-close-x" onClick={() => setIsOpen(false)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
              </button>
              <DialogTitle as="h3">Editează eveniment</DialogTitle>

              <div className="evp-field">
                <label>Imagine eveniment</label>
                <div className="evp-upload">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setImage(file);
                        setPreviewUrl(URL.createObjectURL(file));
                      }
                    }}
                  />
                  <div className="evp-upload-thumb">
                    {previewUrl && <img src={previewUrl} alt="Preview" />}
                  </div>
                  <span className="evp-upload-text">Înlocuiește imaginea evenimentului (opțional)</span>
                </div>
              </div>

              <div className="evp-field">
                <label>Nume eveniment</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="evp-field">
                <label>Dată și oră</label>
                <DatePicker
                  selected={dateTime}
                  onChange={(d) => setDateTime(d)}
                  showTimeSelect
                  timeIntervals={15}
                  timeCaption="Oră"
                  dateFormat="d MMMM yyyy, HH:mm"
                  locale="ro"
                  placeholderText="Selectează data și ora"
                  className="evp-dt-input"
                  calendarClassName="evp-dt-cal"
                  popperClassName="evp-dt-popper"
                  autoComplete="off"
                  required
                />
              </div>

              <div className="evp-field">
                <label>Descriere</label>
                <textarea
                  rows={6}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>

              {error && <p className="evp-msg error">{error}</p>}
              {success && <p className="evp-msg success">{success}</p>}

              <div className="evp-dialog-actions">
                <button type="submit" className="evp-btn-primary"><span>Salvează</span></button>
                <button type="button" className="evp-btn-secondary" onClick={() => setIsOpen(false)}>Anulează</button>
              </div>
            </DialogPanel>
          </form>
        </div>
      </Dialog>
    </div>
  );
}

export default EditEvent;
